import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  signal,
} from '@angular/core';
import { ButtonComponent } from '@fundamental-ngx/core/button';
import { ContentDensityDirective } from '@fundamental-ngx/core/content-density';
import {
  DynamicPageComponent,
  DynamicPageContentComponent,
  DynamicPageHeaderComponent,
} from '@fundamental-ngx/core/dynamic-page';
import {
  IllustratedMessageActionsComponent,
  IllustratedMessageComponent,
  IllustratedMessageFigcaptionComponent,
  IllustratedMessageTextDirective,
  IllustratedMessageTitleDirective,
} from '@fundamental-ngx/core/illustrated-message';
import { addInitListener } from '@luigi-project/client';
import { I18nService, LuigiCoreService } from '@openmfp/portal-ui-lib';

@Component({
  selector: 'app-configuration-missing-handling',
  imports: [
    DynamicPageComponent,
    DynamicPageHeaderComponent,
    DynamicPageContentComponent,
    IllustratedMessageComponent,
    IllustratedMessageActionsComponent,
    IllustratedMessageFigcaptionComponent,
    IllustratedMessageTitleDirective,
    IllustratedMessageTextDirective,
    ButtonComponent,
    ContentDensityDirective,
  ],
  templateUrl: './configuration-missing-handling.component.html',
  styleUrl: './configuration-missing-handling.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurationMissingHandlingComponent implements AfterContentInit {
  readonly config = signal<any>({
    scene: {
      url: 'assets/moments/tnt-Scene-Components.svg',
      id: 'tnt-Scene-Components',
    },
    dialog: {
      url: 'assets/moments/tnt-Dialog-Components.svg',
      id: 'tnt-Dialog-Components',
    },
    illustratedMessageTitle: '',
    illustratedMessageText: '',
  });

  readonly configurationLink = signal('');

  constructor(
    private luigiCoreService: LuigiCoreService,
    private i18nService: I18nService,
  ) {}

  async ngAfterContentInit() {
    this.luigiCoreService.ux().hideAppLoadingIndicator();
    this.i18nService.afterInit();
    addInitListener((ctx) => {
      this.config.update((c) => ({
        ...c,
        illustratedMessageText: ctx.configurationHint,
      }));
      this.configurationLink.set(ctx.configurationLink);
    });
    await this.setConfig();
  }

  link(): void {
    window.open(this.configurationLink(), '_blank', 'noreferrer');
  }

  private async setConfig(): Promise<void> {
    this.config.update((c) => ({
      ...c,
      illustratedMessageTitle: '',
    }));
    const title = await this.i18nService.getTranslationAsync(
      'CONFIGURATION_MISSING_PAGE_TITLE',
    );
    this.config.update((c) => ({
      ...c,
      illustratedMessageTitle: title,
    }));
  }
}
